module.exports = __webpack_public_path__ + "img/CR02EU.9fc98973.png";